import React, { FC } from 'react';
import DownloadButton from '../DownloadButton';
import QuestionBox from './QuestionBox';

const QuestionsContainer: FC = () => {
  return (
    <div className='mt-6 lg:flex'>
      <div className='lg:grid lg:grid-cols-12 lg:gap-6'>
        <div className='lg:col-start-1 lg:col-span-6'>
          <div className='flex flex-col'>
            <QuestionBox
              title='What equipment do I need?'
              body='To start running services, you’ll need a phone or camera to film sermon content, a streaming provider, and the Church Online Platform. We’ll share some options for gear and talk about the differences between simulated live and live.'
              link='/learn/what-equipment-do-you-need-for-church-online'
            />
            <QuestionBox
              title='How quickly can I start running services?'
              body='Churches can begin running services online fairly quickly. Many churches using the Church Online Platform started online ministry in just a few days. If you’ve been thinking about starting online church services for a while, or you’re feeling the pressure to launch quickly—learn all the steps you need to get started.'
              link='/learn/launch-church-online-this-weekend'
            />
          </div>
        </div>
        <div className='lg:col-start-7 lg:col-span-6'>
          <div className='flex flex-col'>
            <div className='inline-block p-4 mt-6 text-left border border-gray-10'>
              <h4 className='group-header'>What staffing do I need?</h4>
              <div className='mt-3 body-paragraph'>
                Churches run online services with a variety of paid and volunteer teams. The
                staffing you need depends on your goals of online ministry and your online
                attendance numbers. Whether your online Hosts are paid or volunteers, get some
                helpful insight into training them in our free guide.
              </div>
              <div className='mt-2'>
                <DownloadButton
                  text='Download the Host guide'
                  link='https://d347bo4ltvvnaz.cloudfront.net/ChurchOnlineHosts_CompleteGuide_.pdf?response-content-disposition=attachment'
                />
              </div>
            </div>
            <QuestionBox
              title='How much does the Platform cost?'
              body='Thanks to the generosity of our global Community, <a class="underline hover:text-primary-hover" href="https://www.youversion.church/" rel="noopener">YouVersion for Churches</a> provides products like Church Online Platform completely for free. '
              link='https://youversion.church'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionsContainer;
